import { setZoneRules } from './format';

/**
 * The time zone settings as last seen, applied before any page module works
 * out its default dates ("the last 30 days") — the server's copy arrives a
 * moment later with the sign-in status, and is saved here for next time.
 */
export const ZONE_STORAGE_KEY = 'ghl-dashboard-time-zones';

try {
  const saved = JSON.parse(localStorage.getItem(ZONE_STORAGE_KEY) ?? 'null') as {
    defaultZone?: string;
    followSubaccount?: boolean;
  } | null;
  if (saved) setZoneRules({ defaultZone: saved.defaultZone || null, followSubaccount: saved.followSubaccount ?? true });
} catch {
  /* first visit, or storage blocked: the browser's zone until the settings load */
}
